import { zodResolver } from '@hookform/resolvers/zod'
import type { FieldValues, Resolver } from 'react-hook-form'
import type { ZodType, ZodTypeDef } from 'zod'

/**
 * Bridges a shared zod schema whose parsed output differs from its form input
 * (`''` → `undefined`, date strings → `Date`) to react-hook-form. Use with
 * `useForm<z.input<S>, unknown, z.output<S>>`.
 */
export function formResolver<TIn extends FieldValues, TOut extends FieldValues>(
  schema: ZodType<TOut, ZodTypeDef, TIn>
): Resolver<TIn, unknown, TOut> {
  return zodResolver(schema as never) as unknown as Resolver<TIn, unknown, TOut>
}
